
import AppCustomTable from "@/components/common/CustomTable.vue";
import { ReminderConfig } from "@/models/dossier-configs/reminder-config";
import Vue from "vue";
import AppSettingsAutomation from "./ReminderSettingsAutomation.vue";
import { ReminderSettings } from "@/models/user-configs/reminder-settings";

export default Vue.extend({
	props: {
		config: {
			type: Object as () => ReminderConfig,
			required: true
		},
		userConfig: {
			type: Object as ()=>ReminderSettings,
			required: true
		}
	},
	components: {
		AppCustomTable,
		AppSettingsAutomation
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
